export const environment = {
    production: true,
    apiUrl: "https://twogetherflower-8456b.ew.r.appspot.com",
    firebaseConfig: {
        apiKey: "AIzaSyDJ55CpgnOdyAea88plMfxjPz8ewCOBXd8",
        authDomain: "twogetherflower-8456b.firebaseapp.com",
        projectId: "twogetherflower-8456b",
        storageBucket: "twogetherflower-8456b.firebasestorage.app",
        messagingSenderId: "675743533214",
        appId: "1:675743533214:web:dd6891aa4db1eee047538f",
        measurementId: "G-F2753BEG43"
      }
  };
